// src/services/modelsAPI.ts
import { fetchWithAuth } from './auth';
import { API_BASE, STATIC_ORIGIN } from '../config';

export const STATIC_BASE = STATIC_ORIGIN;

export type BrandModel = {
  id: number;
  name: string;
  img: string;
};

export async function getModels(): Promise<BrandModel[]> {
  const res = await fetch(`${API_BASE}/models`);
  if (!res.ok) throw new Error(`Ошибка загрузки брендов: ${res.status}`);
  return res.json();
}

export async function createModel(name: string, img: File): Promise<void> {
  const fd = new FormData();
  fd.append('name', name);
  fd.append('img', img);
  const res = await fetchWithAuth(`${API_BASE}/models`, { method: 'POST', body: fd });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error((d as any).message ?? 'Ошибка при создании');
  }
}

export async function updateModel(id: number, name: string, oldImgName: string, img?: File): Promise<void> {
  const fd = new FormData();
  fd.append('id', String(id));
  fd.append('name', name);
  fd.append('oldImgName', oldImgName);
  if (img) fd.append('img', img);
  const res = await fetchWithAuth(`${API_BASE}/models`, { method: 'PATCH', body: fd });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error((d as any).message ?? 'Ошибка при обновлении');
  }
}

export async function deleteModel(id: number): Promise<void> {
  const res = await fetchWithAuth(`${API_BASE}/models/${id}`, { method: 'DELETE' });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error((d as any).message ?? 'Ошибка при удалении');
  }
}
